export default __webpack_public_path__ + "static/media/CuciStep2-1.e025580e.png";